import React, {Component} from 'react';
import {View, Text} from 'react-native';

export const Intro = props => {
  return (
    <View>
      <View style={{height: 20}} />
      <Text
        style={{fontSize: props.fontSize, color: '#44A9C9', fontWeight: '600'}}>
        Mobile App Developer from Guwahati, India mainly focused on Android App
        Development. Started from Java and currently learning{' '}
        <Text
          style={{
            color: '#44A9C9',
            fontWeight: 'bold',
            fontStyle: 'italic',
          }}>
          Flutter(Dart*)
        </Text>
        , after{' '}
        <Text
          style={{
            color: '#44A9C9',
            fontWeight: 'bold',
            fontStyle: 'italic',
          }}>
          React-Native (JS*)
        </Text>{' '}
        and{' '}
        <Text
          style={{
            color: '#44A9C9',
            fontWeight: 'bold',
            fontStyle: 'italic',
          }}>
          Kotlin
        </Text>{' '}
      </Text>
      <View style={{height: 20}} />
      <Text
        style={{color: '#44A9C9', fontSize: props.fontSize, fontWeight: '600'}}>
        I always likes to develop Native Android Apps with Java or Kotlin. All
        other cross platform frameworks are just for pet project for me .
      </Text>
    </View>
  );
};
